import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { RadarBackground } from "./RadarBackground";
import { CtaButtons } from "./CtaButtons";
const heroImage = "https://cdn.magicpatterns.com/uploads/fN3dBZJ8xPnfMaDHiKMoSp/Landing_Page_Hero_Color_Upgrade.png";
export function Hero() {
  const reduce = useReducedMotion();
  return <section id="inicio" className="relative overflow-hidden px-6 pb-20 pt-28 text-center sm:pt-32" data-id="element-50" data-mp="4njng4t9dl8c">
      <div className="relative z-10 mx-auto max-w-3xl" data-id="element-51" data-mp="127eereur1rdz">
        <p className="mb-6 text-sm font-medium text-gold" data-id="element-52" data-mp="xbfkxbqnjh66">Papá · Motero · Emprendedor digital</p>
        <h1 className="mb-5 font-serif text-[clamp(38px,6.4vw,68px)] font-black leading-[1.08] tracking-tight text-white" data-id="element-53" data-mp="sai16upzuf2k">
          Aprendé a vender tu primer <span className="text-gold" data-id="element-54" data-mp="neknkw647mth">ebook digital</span>
        </h1>
        <p className="mx-auto max-w-xl text-[clamp(15px,2.2vw,18px)] leading-relaxed text-soft" data-id="element-55" data-mp="3d33fx1m3uzmc">
          Te enseño el sistema exacto para crear, publicar y vender ebooks con Hotmart y Shopify, aunque nunca hayas
          vendido nada por internet.
        </p>
      </div>

      <div className="relative mx-auto my-12 w-full max-w-[520px]" data-id="element-56" data-mp="3o7vl7nivvtyv">
        <RadarBackground data-id="element-57" data-mp="39acx8ne15ksh" />
        <motion.figure initial={reduce ? false : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative z-10 overflow-hidden rounded-2xl border border-line bg-ink-3" data-id="element-58" data-mp="39b4fyxmj3o1c">
          <img src={heroImage} alt="Marcos Rosell en su moto en la montaña, con notificaciones de ventas de su tienda en el celular" className="aspect-square w-full object-cover" data-id="element-59" data-mp="358zu4l2bnvp9" />
          <figcaption className="absolute bottom-4 left-4 rounded-lg bg-ink/85 px-3.5 py-2 text-[13px] font-medium text-white backdrop-blur-sm" data-id="element-60" data-mp="2vjg48vg6z1kw">
            Vendiendo mientras viajo en moto
          </figcaption>
        </motion.figure>
      </div>

      <div className="relative z-10" data-id="element-61" data-mp="s1rsao8pe6ua">
        <CtaButtons data-id="element-62" data-mp="s2tdhljfo9pq" />
        <p className="mt-5 text-xs text-muted" data-id="element-63" data-mp="s3coeiao1xu9">
          Para personas que quieren vivir de internet y tener tiempo para lo que importa
        </p>
      </div>
    </section>;
}